import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
const initialCustomerGroupsState = {
    entities: [],
    totalCount: null,
    listLoading: false,
    actionsLoading: false,
    message: {
        error: null,
        success: null,
        completed: null,
    },
    currentCustomerGroup: null,
};
export const callTypes = {
    list: "list",
    action: "action",
};
export const customerGroupsSlice = createSlice({
    name: "customerGroups",
    initialState: initialCustomerGroupsState,
    reducers: {
        catchError: (state, action) => {
            let error =
                action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
            if (error.constructor.name === "Object") {
                let temp = [];
                for (let [k, v] of Object.entries(error)) {
                    temp.push(`${k}->${v}`);
                }
                error = temp;
            }
            state.message.error = error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.message.success = null;
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        // customer groups fetched from api
        customerGroupsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        customerGroupCreated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(entity);
            state.totalCount = state.totalCount + 1;
            state.message.success = message;
        },
        customerGroupUpdated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.message.success = message;
            const index = state.entities.findIndex(item => item.id === entity.id);
            if (index >= 0) {
                state.entities[index] = entity;
            } else {
                state.entities.push(entity);
                state.totalCount++;
            }
        },
        customerGroupFetchedById: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.currentCustomerGroup = action.payload.entity;
        },
        resetCurrentCustomerGroup: (state) => {
            state.currentCustomerGroup = null;
        }
    },
});
